'use client'

import { useCallback, useState } from 'react'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/ui/Button'

interface HeroCtaButtonProps {
  label: string
  helperText: string
}

export default function HeroCtaButton({
  label,
  helperText,
}: HeroCtaButtonProps) {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = useCallback(() => {
    setIsLoading(true)
    void import('@/lib/analytics').then(({ analytics }) => {
      analytics.navigation.ctaClicked('start_inviting', 'hero')
    })
    router.push('/designs')
  }, [router])

  return (
    <>
      <div className="animate-fade-up animation-delay-500 motion-safe:hover:scale-[1.05] motion-safe:active:scale-[0.95] transition-transform">
        <Button
          onClick={handleClick}
          size="lg"
          loading={isLoading}
          className="px-6 py-3.5 text-base sm:px-8 sm:py-4 sm:text-lg lg:px-10 lg:py-6 lg:text-xl h-auto shadow-lg hover:shadow-xl transition-shadow"
        >
          {label}
        </Button>
      </div>
      <p className="text-sm sm:text-base md:text-lg text-heading-muted font-medium mt-1 sm:mt-2 animate-fade-up animation-delay-600">
        {helperText}
      </p>
    </>
  )
}
